import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { SplitLayout } from '../layouts/SplitLayout';

export type EmployersRankingTemplateProps = {
  /** A PageHeader stating the measure and its basis in one line. */
  header: ReactNode;
  /** Tabs, one per dimension. */
  tabs?: ReactNode;
  /** RankingRows on one shared scale (grades are letters only). */
  rows: ReactNode;
  /** A standout employer as a BrandSurface rail. */
  standout?: ReactNode;
  /** The A to Z index as links. */
  index?: ReactNode;
  className?: string;
};

/** Best employers: /best-companies, its dimensions, the A to Z list, the employers hub. */
export function EmployersRankingTemplate({
  header,
  tabs,
  rows,
  standout,
  index,
  className,
}: EmployersRankingTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-block py-jc-section">
        {header}
        {tabs}
        <SplitLayout aside={standout} asideWidth="side" stickyAside>
          <div className="divide-y divide-jc-border overflow-hidden rounded-jc-container border border-jc-card-border bg-jc-surface">
            {rows}
          </div>
        </SplitLayout>
        {index}
      </div>
    </PageContainer>
  );
}
